import { jwtDecode } from "jwt-decode";
import usersRequest from "../../request/usersRequest";
import { refreshCognitoTokens } from "../../utils/refreshTokens";
import companyBasedRequest from "../../request/companyBasedRequest";

function clearAuthStorage() {
	localStorage.removeItem("idToken");
	localStorage.removeItem("accessToken");
	localStorage.removeItem("refreshToken");

	sessionStorage.removeItem("idToken");
	sessionStorage.removeItem("accessToken");
	sessionStorage.removeItem("refreshToken");
}

export async function getInitialUserData() {
	try {
		// 1. Get tokens
		const idToken = localStorage.getItem("idToken") || sessionStorage.getItem("idToken");
		const accessToken = localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");
		const refreshToken = localStorage.getItem("refreshToken") || sessionStorage.getItem("refreshToken");

		if (!refreshToken) return null;

		let finalIdToken = idToken;
		let finalAccessToken = accessToken;

		try {
			let shouldRefresh = false;

			if (!accessToken) {
				shouldRefresh = true;
			} else {
				const decoded = jwtDecode(accessToken);
				if (decoded.exp < Date.now() / 1000) {
					shouldRefresh = true;
				}
			}

			if (shouldRefresh) {
				const newTokens = await refreshCognitoTokens(refreshToken);

				finalIdToken = newTokens.id_token;
				finalAccessToken = newTokens.access_token;

				const storage = localStorage.getItem("refreshToken") ? localStorage : sessionStorage;

				storage.setItem("idToken", newTokens.id_token);
				storage.setItem("accessToken", newTokens.access_token);
			}
		} catch (err) {
			console.warn("Token refresh failed:", err);
			clearAuthStorage();
			return null;
		}
		// 3. Decode minimal user (TEMPORARY, NOT TRUSTED)
		let user;
		try {
			const decodedId = jwtDecode(finalIdToken);
			user = {
				userId: decodedId.sub,
				email: decodedId.email,
				firstName: decodedId.given_name,
				lastName: decodedId.family_name,
				phoneNumber: decodedId.phone_number,
				role: decodedId["custom:role"],
			};
		} catch (err) {
			clearAuthStorage();
			return null;
		}

		// 4. 🔥 Validate session via /me (SOURCE OF TRUTH)
		let me;
		try {
			const data = await usersRequest.me(finalAccessToken);
			if (!data?.user) throw new Error("Invalid /me response");
			me = data.user;
		} catch (err) {
			console.warn("❌ /me failed — logging out", err);
			clearAuthStorage();
			return null;
		}

		user = { ...user, ...me };

		// 5. Fetch shop only if admin / owner
		let shop = null;
		if ((user.role === "admin" || user.role === "owner") && user.shopId) {
			try {
				const res = await companyBasedRequest.getShopWithstaffsByIdPrivate(user.shopId, finalAccessToken);
				shop = res?.shop || null;
				localStorage.setItem("shop", JSON.stringify(shop));
			} catch (err) {
				console.warn("Failed fetching shop:", err);
			}
		}

		// ✅ Fully valid session
		return {
			cognitoTokens: {
				IdToken: finalIdToken,
				AccessToken: finalAccessToken,
				RefreshToken: refreshToken || null,
			},
			user,
			shop,
		};
	} catch (err) {
		console.error("Error in getInitialUserData:", err);
		clearAuthStorage();
		return null;
	}
}
